module.exports = __webpack_public_path__ + "static/media/iphone-blackscreen.b03e026a.png";